<div class="pill-container">
  <app-pill
    [padding]="'0.75rem 1.5rem'"
    [disabled]="disabled"
    [activeCount]="activeFiltersCount"
    [selected]="showingFilterWindow"
    [imageSrc]="'assets/icons/dark/Adjustments.svg'"
    text="Filters"
    i18n-text
    (clicked)="filterPillClicked.emit()" />
  <app-pill
    *ngIf="activeSearchCount"
    class="search-pill"
    text="Clear Searches"
    i18n-text
    [padding]="'0.75rem 1.5rem'"
    [imageSrc]="'assets/icons/primary/X.svg'"
    [activeCount]="activeSearchCount"
    (clicked)="searchPillClicked.emit()" />
</div>
